.list-view-special-state-text {
    display: flex;
    justify-content: center;
    text-align: center;
    padding: 40px 32px;
}
